import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UrlHelperService } from "libraries/service/url-helper/url-helper.service";

@NgModule({
    imports: [
        CommonModule,
    ],
    providers: [
        UrlHelperService
    ],
})
export class UrlHelperModule {
}
